import { readAppManifest } from '../../app-manifest/file.js';

export async function loadDevCenterComponents(projectFolder: string) {
  try {
    const manifest = await readAppManifest({ projectFolder });
    return manifest.components;
  } catch {
    return [];
  }
}
